import { ApiClient } from './client';
import type { EnglishLevel } from '@/types/story.types';

export interface LevelTestQuestion {
  id: string;
  level: EnglishLevel;
  question: string;
  options: string[];
  correctAnswerIndex: number;
}

export interface LevelTestResult {
  level: EnglishLevel;
  score: number;
  totalQuestions: number;
  correctAnswers: number;
  levelBreakdown: Record<EnglishLevel, { correct: number; total: number }>;
}

/**
 * Get level test questions from backend
 */
export async function getLevelTestQuestions(): Promise<LevelTestQuestion[]> {
  return ApiClient.get<LevelTestQuestion[]>('/level-test/questions');
}

/**
 * Submit level test answers and get result
 * Requires JWT - saves level to user
 * @deprecated Flujo antiguo (banco en BD). El test nuevo calcula el nivel en
 * cliente y lo persiste con `submitLevelTestResult`.
 */
export async function submitLevelTest(
  answers: Record<string, number>
): Promise<LevelTestResult> {
  return ApiClient.post<LevelTestResult>('/level-test/submit', { answers });
}

export interface LevelTestResultPayload {
  /** Nivel determinado por el motor adaptativo en cliente (A1–C2). */
  level: EnglishLevel;
  /** Aciertos sobre total de la sesión (opcional, solo registro). */
  score?: number;
  /** Perfil por competencia { L, G, V } como nivel A1–C2 (opcional, registro). */
  skillProfile?: Partial<Record<'L' | 'G' | 'V', EnglishLevel>>;
}

/**
 * Persiste el nivel calculado por el motor cliente del test de nivel.
 * Requiere JWT. Fija users.level + levelTestCompletedAt, notifica el cambio de
 * nivel y siembra las historias semanales iniciales.
 */
export async function submitLevelTestResult(
  payload: LevelTestResultPayload
): Promise<{ level: EnglishLevel }> {
  return ApiClient.post<{ level: EnglishLevel }>('/level-test/result', payload);
}
